import { effect, Injectable, signal } from '@angular/core';

export type Theme = 'light' | 'dark';

export const FONT_SIZES = [10, 12, 14] as const;
export type FontSize = (typeof FONT_SIZES)[number];

export const DARK_THEME_CLASS = 'app-dark';

const THEME_KEY = 'theme';
const FONT_SIZE_KEY = 'fontSize';
const DEFAULT_FONT_SIZE: FontSize = 14;

@Injectable({
  providedIn: 'root',
})
export class AppearanceService {
  readonly theme = signal<Theme>(readTheme());
  readonly fontSize = signal<FontSize>(readFontSize());

  constructor() {
    effect(() => {
      const theme = this.theme();
      document.documentElement.classList.toggle(DARK_THEME_CLASS, theme === 'dark');
      localStorage.setItem(THEME_KEY, theme);
    });

    effect(() => {
      const fontSize = this.fontSize();
      document.documentElement.style.fontSize = `${fontSize}px`;
      localStorage.setItem(FONT_SIZE_KEY, fontSize.toString());
    });
  }
}

function readTheme(): Theme {
  return localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light';
}

function readFontSize(): FontSize {
  const saved = Number(localStorage.getItem(FONT_SIZE_KEY));
  return FONT_SIZES.find((size) => size === saved) ?? DEFAULT_FONT_SIZE;
}
